/* eslint-disable @calm/react-intl/missing-formatted-message */

import { MouseEvent, useContext, useState } from 'react';

import { Button } from '@calm-web/design-system';

import AuthModal from '@/components/authForm/AuthModal';
import { useAuthPrompt } from '@/context/auth/AuthPromptProvider';
import { AuthModalContext } from '@/context/AuthModalContextProvider';
import { useLoginForm } from '@/hooks/forms';
import { useUserState } from '@/hooks/store';

import { ChangeMessage, FormWrapper, Note, Title } from './styles';

export default function ClassicUser() {
	const user = useUserState();

	const [message, setMessage] = useState('');
	const { onLogout } = useLoginForm();
	const { setAuthPrompt } = useAuthPrompt();
	const { setIsModalOpen } = useContext(AuthModalContext);

	function onLoginClick(event: MouseEvent<HTMLButtonElement>): void {
		event.stopPropagation();
		event.preventDefault();
		setAuthPrompt('login');
		if (setIsModalOpen) {
			setIsModalOpen(true);
		}
	}

	async function onAuthSuccess(): Promise<void> {
		if (setIsModalOpen) {
			setIsModalOpen(false);
		}
		setMessage('');
	}

	return (
		<FormWrapper>
			<Title>User</Title>
			{user ? (
				<Note>
					<div>{user.name}</div>
					<div>{user.email}</div>
					<div>{user.id}</div>
				</Note>
			) : (
				<Button backgroundColor="buttonLime" legacyOnClick={onLoginClick}>
					Login / Signup
				</Button>
			)}
			{message && <ChangeMessage>{message}</ChangeMessage>}
			<AuthModal onAuthSuccess={onAuthSuccess} />
			{user && (
				<Button backgroundColor="buttonLime" onPress={onLogout}>
					Logout
				</Button>
			)}
		</FormWrapper>
	);
}
